import React from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import Home from './pages/Home';

// Create a minimal theme for the application
const theme = createTheme({
  palette: {
    background: {
      default: '#fcfcfc', // Very subtle off-white for contrast
    },
    primary: {
      main: '#FFC800', // UDEM yellow, roughly
    },
    text: {
      primary: '#1a1a1a',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          '&:hover .MuiCardActionArea-focusHighlight': {
            opacity: 0, // Remove default grey overlay on hover
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Home />
    </ThemeProvider>
  );
}

export default App;
